import {TimelineMax, TweenMax} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');

// console.log(CustomEase)

const body = document.body;

const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');



    const bgImg = Shortcuts.getSprite('finBg', TextureCache, 'bgImg');
    const bg = new PIXI.Container();
    bg.addChild(bgImg);

    const view = new PIXI.Container();
    const shadow = new PIXI.Container();

    const shadowCM = new PIXI.filters.ColorMatrixFilter();
    shadowCM.matrix = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0];

    const cm1 = new PIXI.filters.ColorMatrixFilter();
    cm1.greyscale(0.3);
    const p1 = new PIXI.Container();
    const p1sh = new PIXI.Container();
    Shortcuts.addTo(Shortcuts.getSprite('p1_s1', TextureCache), 's1', p1);
    Shortcuts.addTo(Shortcuts.getSprite('p1_s2', TextureCache), 's2', p1);
    Shortcuts.addTo(Shortcuts.getSprite('p1_s3', TextureCache), 's3', p1);
    Shortcuts.addTo(Shortcuts.getSprite('p1_s1', TextureCache), 's1', p1sh);
    Shortcuts.addTo(Shortcuts.getSprite('p1_s2', TextureCache), 's2', p1sh);
    Shortcuts.addTo(Shortcuts.getSprite('p1_s3', TextureCache), 's3', p1sh);
    p1.s1.anchor.set(0.5, 1100 / 1573);
    p1.s2.anchor.set(0.5, 1100 / 1573);
    p1.s3.anchor.set(0.5, 1100 / 1573);
    p1sh.s1.anchor.set(0.5, 1100 / 1573);
    p1sh.s2.anchor.set(0.5, 1100 / 1573);
    p1sh.s3.anchor.set(0.5, 1100 / 1573);
    p1.filters = [cm1];
    p1sh.filters = [shadowCM];


    const p2 = new PIXI.Container();
    const p2sh = new PIXI.Container();
    Shortcuts.addTo(Shortcuts.getSprite('p2_s1', TextureCache), 's1', p2);
    Shortcuts.addTo(Shortcuts.getSprite('p2_s1', TextureCache), 's2', p2);
    Shortcuts.addTo(Shortcuts.getSprite('p2_s1', TextureCache), 's3', p2);
    Shortcuts.addTo(Shortcuts.getSprite('info1', TextureCache), 'info', p2);
    Shortcuts.addTo(Shortcuts.getSprite('p2_s1', TextureCache), 's1', p2sh);
    Shortcuts.addTo(Shortcuts.getSprite('p2_s1', TextureCache), 's2', p2sh);
    Shortcuts.addTo(Shortcuts.getSprite('p2_s1', TextureCache), 's3', p2sh);
    p2.info.anchor.set(0.5, 0.5);
    p2.info.position.set(-0.25 * sizes.width, -0.5 * sizes.height);

    p2.s2.scale.set(-1, 1);
    p2.s3.scale.set(-1, 1);
    p2sh.s2.scale.set(-1, 1);
    p2sh.s3.scale.set(-1, 1);

    p2.s1.anchor.set(0.5, 1100 / 1455);
    p2.s2.anchor.set(0.47, 0.997 * 1100 / 1455);
    p2.s3.anchor.set(0.53, 1.007 * 1100 / 1455);
    p2sh.s1.anchor.set(0.5, 1100 / 1455);
    p2sh.s2.anchor.set(0.47, 0.997 * 1100 / 1455);
    p2sh.s3.anchor.set(0.53, 1.007 * 1100 / 1455);
    p2sh.filters = [shadowCM];


    const p3 = new PIXI.Container();
    const p3sh = new PIXI.Container();
    let scale = 1395 / 1149;
    Shortcuts.addTo(Shortcuts.getSprite('info2', TextureCache), 'info', p3);
    Shortcuts.addTo(Shortcuts.getSprite('p3_s1', TextureCache), 's1', p3);
    Shortcuts.addTo(Shortcuts.getSprite('p3_s1', TextureCache), 's2', p3);
    Shortcuts.addTo(Shortcuts.getSprite('p3_s2', TextureCache), 's3', p3);
    Shortcuts.addTo(Shortcuts.getSprite('info2_2', TextureCache), 'info2', p3);
    Shortcuts.addTo(Shortcuts.getSprite('p3_s1', TextureCache), 's1', p3sh);
    Shortcuts.addTo(Shortcuts.getSprite('p3_s1', TextureCache), 's2', p3sh);
    Shortcuts.addTo(Shortcuts.getSprite('p3_s2', TextureCache), 's3', p3sh);
    p3.info.anchor.set(1, 0);
    p3.info.scale.set(1 / scale, 1 / scale);
    p3.info.position.set(0.5 * sizes.width / scale, -sizes.height * 1.2 / scale);
    p3.info2.anchor.set(1, 0);
    p3.info2.scale.set(1 / scale, 1 / scale);
    p3.info2.position.set(0.46 * sizes.width / scale, -sizes.height * 0.95 / scale);

    scale = 873 / 1149;
    p3.s1.anchor.set(0.5, scale);
    p3.s2.anchor.set(0.45, 0.995 * scale);
    p3.s3.anchor.set(0.5, scale);
    p3sh.s1.anchor.set(0.5, scale);
    p3sh.s2.anchor.set(0.45, 0.995 * scale);
    p3sh.s3.anchor.set(0.5, scale);
    p3sh.filters = [shadowCM];


    const p4 = new PIXI.Container();
    const p4sh = new PIXI.Container();
    scale = 1020 / 680;
    Shortcuts.addTo(Shortcuts.getSprite('p4_s1', TextureCache), 's1', p4);
    Shortcuts.addTo(Shortcuts.getSprite('p4_s1', TextureCache), 's2', p4);
    Shortcuts.addTo(Shortcuts.getSprite('p4_s1', TextureCache), 's3', p4);
    Shortcuts.addTo(Shortcuts.getSprite('p4_d1', TextureCache), 'd1', p4);
    Shortcuts.addTo(Shortcuts.getSprite('p4_d2', TextureCache), 'd2', p4);
    Shortcuts.addTo(Shortcuts.getSprite('p4_d3', TextureCache), 'd3', p4);
    Shortcuts.addTo(Shortcuts.getSprite('p4_s1', TextureCache), 's1', p4sh);
    Shortcuts.addTo(Shortcuts.getSprite('p4_s1', TextureCache), 's2', p4sh);
    Shortcuts.addTo(Shortcuts.getSprite('p4_s1', TextureCache), 's3', p4sh);
    Shortcuts.addTo(Shortcuts.getSprite('p4_d1', TextureCache), 'd1', p4sh);
    Shortcuts.addTo(Shortcuts.getSprite('p4_d2', TextureCache), 'd2', p4sh);
    Shortcuts.addTo(Shortcuts.getSprite('p4_d3', TextureCache), 'd3', p4sh);
    Shortcuts.addTo(Shortcuts.getSprite('info3', TextureCache), 'info', p4);
    p4.info.anchor.set(0.5, 0.5);
    p4.info.scale.set(0.9 / scale, 0.9 / scale);
    p4.info.position.set(0.25 * sizes.width / scale, -sizes.height * 0.75 / scale);
    p4.s1.anchor.set(0.5, 1);
    p4.s2.anchor.set(0.56, 0.995);
    p4.s3.anchor.set(0.53, 0.99);
    p4.d1.anchor.set(0.5, 1);
    p4.d2.anchor.set(0.52, 1.1);
    p4.d3.anchor.set(0.5, 1.2);
    p4sh.s1.anchor.set(0.5, 1);
    p4sh.s2.anchor.set(0.575, 0.995);
    p4sh.s3.anchor.set(0.55, 0.99);
    p4sh.d1.anchor.set(0.5, 1);
    p4sh.d2.anchor.set(0.52, 1.1);
    p4sh.d3.anchor.set(0.5, 1.2);
    p4sh.filters = [shadowCM];

    p4.d1.position.set(221, -483);
    p4.d2.position.set(221, -483);
    p4.d3.position.set(221, -483);
    p4sh.d1.position.set(221, -483);
    p4sh.d2.position.set(221, -483);
    p4sh.d3.position.set(221, -483);


    const p5 = new PIXI.Container();
    Shortcuts.addTo(Shortcuts.getSprite('finBg', TextureCache), 'bg', p5);
    Shortcuts.addTo(Shortcuts.getSprite('p5_main', TextureCache), 'main', p5);
    Shortcuts.addTo(Shortcuts.getSprite('p5_s1', TextureCache), 'd1', p5);
    Shortcuts.addTo(Shortcuts.getSprite('p5_s2', TextureCache), 'd2', p5);
    Shortcuts.addTo(Shortcuts.getSprite('p5_s3', TextureCache), 'd3', p5);
    p5.bg.anchor.set(1, 1);
    p5.bg.scale.set(-1, -1);

    p1.position.set(sizes.width / 2, sizes.height);
    p2.position.set(sizes.width / 2, sizes.height);
    p3.position.set(sizes.width / 2, sizes.height);
    p4.position.set(sizes.width * 0.55, sizes.height);
    p5.position.set(0, 0);

    p1sh.position.set(sizes.width * 0.53, sizes.height);
    p2sh.position.set(sizes.width * 0.53, sizes.height);
    p3sh.position.set(sizes.width * 0.53, sizes.height);
    p4sh.position.set(sizes.width * 0.6, sizes.height);

    p3.scale.set(1395 / 1149);
    p3sh.scale.set(1395 / 1149);
    p4.scale.set(1020 / 680);
    p4sh.scale.set(1020 / 680);


    p1.timeline = _getInnerTimelineNum3(p1, 4.6);
    p2.timeline = _getInnerTimelineNum3(p2, 4.6, 0.5);
    p3.timeline = _getInnerTimelineNum3(p3, 4.1, 0.5);
    p4.timeline = _getInnerTimelineNum3(p4, 4.1, 0.5);
    p5.timeline = _getLoopedTimeline(p5, 8);
    p1.reversed = p2.reversed = p3.reversed = p4.reversed = p5.reversed = true;
    p1.shown = p2.shown = p3.shown = p4.shown = p5.shown = false;

    p1sh.timeline = _getInnerTimelineNum3(p1sh, 4.6);
    p2sh.timeline = _getInnerTimelineNum3(p2sh, 4.6, 0.5);
    p3sh.timeline = _getInnerTimelineNum3(p3sh, 4.1, 0.5);
    p4sh.timeline = _getInnerTimelineNum3(p4sh, 4.1, 0.5);
    p1sh.reversed = p2sh.reversed = p3sh.reversed = p4sh.reversed = true;
    p1sh.shown = p2sh.shown = p3sh.shown = p4sh.shown = false;

    p4.smokeTimeline = _getLoopedTimeline(p4, 4);
    p4sh.smokeTimeline = _getLoopedTimeline(p4sh, 4);

    p1sh.progress =
    p2sh.progress =
    p3sh.progress =
    p4sh.progress =
    p1.progress =
    p2.progress =
    p3.progress =
    p4.progress =
    p5.progress = 0;

    shadow.addChild(p2sh);
    shadow.addChild(p3sh);
    shadow.addChild(p4sh);
    shadow.addChild(p1sh);

    view.addChild(p2);
    view.addChild(p3);
    view.addChild(p4);
    view.addChild(p1);

    cont.addChild(bg);
    cont.addChild(shadow);
    cont.addChild(p5);
    cont.addChild(view);

    cont.alpha = 0;
    shadow.z = -0.5;
    view.z = 0.3;

    p2.info.z = 0.2;
    p3.info.z = -0.6;
    p3.info2.z = 0.2;
    p4.info.z = 0.2;

    instance.cont = cont;
    instance.width = sizes.width;
    instance.height = sizes.height;
    instance.bg = bg;
    instance.view = view;
    instance.shadow = shadow;
    instance.p1 = p1;
    instance.p2 = p2;
    instance.p3 = p3;
    instance.p4 = p4;
    instance.p5 = p5;
    instance.p1sh = p1sh;
    instance.p2sh = p2sh;
    instance.p3sh = p3sh;
    instance.p4sh = p4sh;
    instance.cm1 = cm1;
    instance.shadowOn = 0;

    instance.parallaxLayers = [view, shadow, p2.info, p4.info, p3.info, p3.info2];
    instance.root.addChild(cont);
}

const _destroyTimelines = instance => {
    instance.p1.timeline.kill();
    instance.p2.timeline.kill();
    instance.p3.timeline.kill();
    instance.p4.timeline.kill();
    instance.p5.timeline.kill();
    instance.p4.smokeTimeline.kill();
    instance.p1sh.timeline.kill();
    instance.p2sh.timeline.kill();
    instance.p3sh.timeline.kill();
    instance.p4sh.timeline.kill();
    instance.p4sh.smokeTimeline.kill();
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}

const _getInnerTimelineNum3 = (p, d, delay) => {

    const tl = new TimelineMax({paused: true});

    TweenMax.set(p.s1, {alpha: 1});
    TweenMax.set([p.s2, p.s3], {alpha: 0});
    tl.set(p.s1, {alpha: 1}, 'in');
    tl.set([p.s2, p.s3], {alpha: 0}, 'in');

    const a = 1 / 0.85;

    tl.to(p.s1, d * a * 0.2, {alpha: 0}, 'in+=' + (delay + d * a * 0.2));
    tl.to(p.s2, d * a * 0.2, {alpha: 1}, 'in+=' + (delay + d * a * 0.21));
    tl.to(p.s2, d * a * 0.25, {alpha: 0}, 'in+=' + (delay + d * a * 0.41));
    tl.to(p.s3, d * a * 0.25, {alpha: 1}, 'in+=' + (delay + d * a * 0.42));

    tl.set(p.s3, {alpha: 1}, 'off');
    tl.set([p.s2, p.s1], {alpha: 0}, 'off');

    return tl;
};

const _getLoopedTimeline = (p, d) => {
    TweenMax.set(p.d1, {alpha: 1});
    TweenMax.set(p.d2, {alpha: 0});
    TweenMax.set(p.d3, {alpha: 0});
    const a = 1 / 0.76;

    const tl = new TimelineMax({paused: false, onComplete: _getLoopedTimeline, onCompleteParams: [p, d]});

    tl.to(p.d1, 0, {alpha: 1}, 'in');
    tl.to(p.d2, 0, {alpha: 0}, 'in');
    tl.to(p.d3, 0, {alpha: 0}, 'in');
    tl.to(p.d1, d * a * 0.22, {alpha: 0}, 'in');
    tl.to(p.d2, d * a * 0.25, {alpha: 1}, 'in+=' + d * a * 0.01);
    tl.to(p.d2, d * a * 0.24, {alpha: 0}, 'in+=' + d * a * 0.23);
    tl.to(p.d3, d * a * 0.26, {alpha: 1}, 'in+=' + d * a * 0.24);
    tl.to(p.d3, d * a * 0.28, {alpha: 0}, 'in+=' + d * a * 0.47);
    tl.to(p.d1, d * a * 0.28, {alpha: 1}, 'in+=' + d * a * 0.5);

    return tl;
}

const _updateTimeline = (p, delay) => {
    const tl = p.timeline;
    /* if(!tl.isActive()) {
        tl.seek(p.progress > 0.5 ? 0.999 : 0.01);
    }*/

    if (p.progress > 0.01 && p.progress < 0.99) {
        if (!p.shown) {
            TweenMax.killTweensOf(p, {alpha: true});
            TweenMax.to(p, 0.65, {delay: delay, alpha: 1});
            p.shown = true;
        }
    } else {
        if (p.shown) {
            TweenMax.killTweensOf(p, {alpha: true});
            TweenMax.to(p, 0.6, {alpha: 0});
            p.shown = false;
        }
    }

    const prevProgress = p.prevProgress;
    p.prevProgress = p.progress;

    if (!tl || prevProgress === void 0 || p.progress - prevProgress === 0) return;

    if (p.progress - prevProgress > 0) {
        if (!p.reversed) return;
        tl.play();
        p.reversed = false;
        return;
    }
    if (p.reversed) return;
    tl.reverse();
    p.reversed = true;
}

const _constructTimeline = instance => {
    const tl = new TimelineMax({
        paused: true,
        onUpdate: () => {

            _updateTimeline(instance.p1);
            _updateTimeline(instance.p2, 0.65);
            _updateTimeline(instance.p3, 0.65);
            _updateTimeline(instance.p4, 0.65);
            _updateTimeline(instance.p5, 0.65);

            _updateTimeline(instance.p1sh);
            _updateTimeline(instance.p2sh, 0.65);
            _updateTimeline(instance.p3sh, 0.65);
            _updateTimeline(instance.p4sh, 0.65);

            body.dataset.finText = instance.shadowOn > 0;

        }
    });
    let T = 0;

    tl.set([
        instance.cont,
        instance.bg,
        instance.p1,
        instance.p2,
        instance.p3,
        instance.p4,
        instance.p5,
        instance.p1sh,
        instance.p2sh,
        instance.p3sh,
        instance.p4sh
    ], {alpha: 0}, 'in');

    tl.set([
        instance.p1
    ], {progress: 0}, 'in');

    tl.set(instance.cm1.matrix, {0: 0.3, 6: 0.3, 12: 0.3, 1: 0.3, 2: 0.3, 5: 0.3, 7: 0.3, 10: 0.3, 11: 0.3}, 'in');

    // from [0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 1, 0]
    // to [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]

    tl.to(instance.cont, 0, {alpha: 1}, 'in');
    tl.to(instance, 0, {shadowOn: 1}, 'in');


    tl.to(instance.bg, 0.9, {alpha: 1}, 'in+=' + T);

    tl.to(instance.p1, 0.1, {progress: 0.1}, 'in+=' + (T + 0.1));
    tl.to(instance.p1sh, 0.1, {progress: 0.1}, 'in+=' + (T + 0.1));

    T += 2;
    tl.to(instance.cm1.matrix, 0.3, {0: 1, 6: 1, 12: 1, 1: 0, 2: 0, 5: 0, 7: 0, 10: 0, 11: 0}, 'in+=' + T);

    tl.to(instance.p1, 0.1, {progress: 0.9}, 'in+=' + T);
    tl.to(instance.p1sh, 0.1, {progress: 0.9}, 'in+=' + T);
    T += 0.5;

    // TO p2
    T += 1.2 + 1;
    tl.to(instance.p1, 0.1, {progress: 1}, 'in+=' + T);
    tl.to(instance.p1sh, 0.1, {progress: 1}, 'in+=' + T);

    tl.to(instance.p2, 0.1, {progress: 0.9}, 'in+=' + T);
    tl.to(instance.p2sh, 0.1, {progress: 0.9}, 'in+=' + T);

    T += 0.65;
    T += 0.65;

    // TO p3
    T += 1.2 + 1;
    tl.to(instance.p2, 0.1, {progress: 1}, 'in+=' + T);
    tl.to(instance.p2sh, 0.1, {progress: 1}, 'in+=' + T);

    tl.to(instance.p3, 0.1, {progress: 0.9}, 'in+=' + T);
    tl.to(instance.p3sh, 0.1, {progress: 0.9}, 'in+=' + T);

    T += 0.65;
    T += 0.65;

    // TO p4
    T += 1.2 + 1;
    T += 1.2;
    tl.to(instance.p3, 0.1, {progress: 1}, 'in+=' + T);
    tl.to(instance.p3sh, 0.1, {progress: 1}, 'in+=' + T);

    tl.to(instance.p4, 0.1, {progress: 0.9}, 'in+=' + T);
    tl.to(instance.p4sh, 0.1, {progress: 0.9}, 'in+=' + T);

    T += 0.65;
    T += 0.65;

    // TO p5
    T += 1.2 + 1;
    T += 1.2;
    tl.to(instance.p4, 0.1, {progress: 1}, 'in+=' + T);
    tl.to(instance.p4sh, 0.1, {progress: 1}, 'in+=' + T);

    tl.to(instance.p5, 0.1, {progress: 0.9}, 'in+=' + T);

    T += 1.2 + 1;
    T += 1.2;
    T += 2;

    tl.to([
        instance.cont,
        instance.bg,
        instance.p1,
        instance.p2,
        instance.p3,
        instance.p4,
        instance.p5,
        instance.p1sh,
        instance.p2sh,
        instance.p3sh,
        instance.p4sh
    ], 0, {alpha: 0}, 'in+=' + T);

    tl.to(instance, 0, {shadowOn: 0}, 'in+=' + T);

    // tl.to(instance.cont, 0, {alpha: 0}, 'off');


    instance.timeline = tl;
    return tl;
}


function FinTimelineConstructor(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _destroyTimelines(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = 0.25;
    constructor.totalDuration = 16 + 6 + 1;       // 2 - fade delay

    return constructor;
}


module.exports = FinTimelineConstructor;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/FinTimeline.js